// src/ConfirmScreen.js
// End-of-Zoom-1 confirm screen (screen-share ritual, locked Aug 4 2026):
// risk number → assigned portfolio tier → Zoom 2 date → secure statement upload.
// Shown only when a Risk Score exists AND the Zoom 2 date is set.
import './ConfirmScreen.css';

function fmtZoom2(dt) {
  if (!dt) return '';
  const d = new Date(dt);
  if (isNaN(d)) return dt;
  return d.toLocaleString('en-US', {
    weekday: 'long', month: 'long', day: 'numeric',
    hour: 'numeric', minute: '2-digit',
  });
}

export function ConfirmScreen({ clientName, riskScore, tier, zoom2Date, uploadUrl, onClose }) {
  const first = (clientName || '').trim().split(' ')[0];
  const pct = tier ? Math.round(tier.planningRate * 100) : null;
  const displayUrl = (uploadUrl || '').replace(/^https?:\/\//, '');

  return (
    <div className="cs-overlay" onMouseDown={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="cs-screen" role="dialog" aria-modal="true" aria-label="Zoom 1 confirmation">
        <button className="cs-close" onClick={onClose} aria-label="Close">✕</button>

        <div className="cs-eyebrow">J BRADIN FINANCIAL · ROTH CONVERT ENGINE</div>
        <h1 className="cs-title">{first ? `${first}, here's where we are.` : "Here's where we are."}</h1>

        <div className="cs-grid">
          <div className="cs-card">
            <div className="cs-card-label">Your Risk Number</div>
            <div className="cs-card-hero">{riskScore?.composite ?? '—'}</div>
            <div className="cs-card-sub">{riskScore?.band}</div>
          </div>

          <div className="cs-card cs-card-gold">
            <div className="cs-card-label">Your Convert Engine Portfolio</div>
            <div className="cs-card-hero cs-card-hero-tier">{tier?.label ?? '—'}</div>
            <div className="cs-card-sub">{tier?.sub}{pct != null ? ` · ${pct}% planning rate` : ''}</div>
            <div className="cs-card-note">Matched to your risk number — built into your full plan for our next meeting.</div>
          </div>

          <div className="cs-card">
            <div className="cs-card-label">Your Plan Review — Zoom 2</div>
            <div className="cs-card-hero cs-card-hero-date">{fmtZoom2(zoom2Date)}</div>
            <div className="cs-card-note">Bring your spouse — this is the meeting where we review everything.</div>
          </div>
        </div>

        <div className="cs-upload">
          <div className="cs-upload-label">One thing before we meet</div>
          <div className="cs-upload-text">
            Upload your account statements so your plan is built from your exact numbers — not estimates.
            Feel free to black out Social Security and account numbers; we only need the balances.
          </div>
          <div className="cs-upload-url">{displayUrl}</div>
          <div className="cs-upload-hint">Use the same email you booked with. The link is also in your confirmation email.</div>
        </div>

        <div className="cs-footer">A fiduciary process — you decide, at your pace. Nothing is sold on these calls.</div>
      </div>
    </div>
  );
}
